/**
 * ero-gallery.js — v4 global
 * Sol dikey thumbnail (5 görünür + ok nav) + 513px büyük resim + hover zoom
 */

const ERO_VISIBLE      = 5;
const ERO_ITEM_H       = 76;
const ERO_GAP          = 8;
const ERO_STEP         = ERO_ITEM_H + ERO_GAP; // 84px
const ERO_SWIPE_THRESH = 40;

class EroGallery {
  constructor(root) {
    this.root       = root;
    this.track      = root.querySelector('.ero-gallery__track');
    this.slides     = Array.from(root.querySelectorAll('.ero-gallery__slide'));
    this.dots       = Array.from(root.querySelectorAll('.ero-gallery__dot'));
    this.thumbList  = root.querySelector('.ero-gallery__thumb-list');
    this.thumbItems = Array.from(root.querySelectorAll('.ero-gallery__thumb-item'));
    this.navUp      = root.querySelector('.ero-gallery__nav--up');
    this.navDown    = root.querySelector('.ero-gallery__nav--down');
    this.mainEl     = root.querySelector('.ero-gallery__main');

    this.current   = 0;
    this.offset    = 0;
    this.maxOffset = Math.max(0, this.thumbItems.length - ERO_VISIBLE);

    if (!this.track || this.slides.length === 0) return;

    this._bindThumbs();
    this._bindNav();
    this._bindDots();
    this._initSwipe();
    this._initZoom();
    this._updateNav();
    this._setActive(0);
  }

  _bindThumbs() {
    this.thumbItems.forEach((item, i) => {
      const btn = item.querySelector('.ero-gallery__thumb-btn');
      if (!btn) return;
      btn.addEventListener('click', () => this.goTo(i));
    });
  }

  _bindNav() {
    if (this.navUp)   this.navUp.addEventListener('click',   () => this._shiftThumbs(-1));
    if (this.navDown) this.navDown.addEventListener('click', () => this._shiftThumbs(1));
  }

  _bindDots() {
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });
  }

  goTo(index) {
    if (index < 0 || index >= this.slides.length) return;
    this.current = index;
    this.track.style.transform = `translateX(-${index * 100}%)`;
    this._setActive(index);
    this._ensureThumbVisible(index);
  }

  _setActive(index) {
    this.slides.forEach((s, i) =>
      s.classList.toggle('is-active', i === index)
    );
    this.thumbItems.forEach((t, i) =>
      t.classList.toggle('is-active', i === index)
    );
    this.dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === index);
      d.setAttribute('aria-pressed', String(i === index));
    });
  }

  _shiftThumbs(dir) {
    this.offset = Math.min(Math.max(this.offset + dir, 0), this.maxOffset);
    if (this.thumbList) {
      this.thumbList.style.transform = `translateY(-${this.offset * ERO_STEP}px)`;
    }
    this._updateNav();
  }

  _updateNav() {
    if (this.navUp)   this.navUp.disabled   = this.offset === 0;
    if (this.navDown) this.navDown.disabled  = this.offset >= this.maxOffset;
  }

  _ensureThumbVisible(index) {
    if (!this.thumbList) return;
    const end = this.offset + ERO_VISIBLE - 1;
    if (index < this.offset) {
      this.offset = index;
    } else if (index > end) {
      this.offset = index - ERO_VISIBLE + 1;
    } else {
      return;
    }
    this.offset = Math.min(Math.max(this.offset, 0), this.maxOffset);
    this.thumbList.style.transform = `translateY(-${this.offset * ERO_STEP}px)`;
    this._updateNav();
  }

  _initZoom() {
    if (!this.mainEl) return;

    this.mainEl.addEventListener('mousemove', (e) => {
      const rect = this.mainEl.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(2);
      const y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(2);
      const img = this.slides[this.current]
                    ? this.slides[this.current].querySelector('.ero-gallery__img')
                    : null;
      if (!img) return;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform       = 'scale(2.2)';
      img.style.transition      = 'transform 0s';
    });

    this.mainEl.addEventListener('mouseleave', () => {
      const img = this.slides[this.current]
                    ? this.slides[this.current].querySelector('.ero-gallery__img')
                    : null;
      if (!img) return;
      img.style.transform  = 'scale(1)';
      img.style.transition = 'transform 300ms ease';
    });
  }

  _initSwipe() {
    if (!this.mainEl) return;
    let startX = 0, startY = 0, locked = false, swipeEndTimer = null;

    this.mainEl.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      locked = false;
      // Reactive will-change: GPU layer hint'i sadece swipe süresince
      if (swipeEndTimer) clearTimeout(swipeEndTimer);
      this.mainEl.classList.add('is-swiping');
    }, { passive: true });

    this.mainEl.addEventListener('touchmove', (e) => {
      if (locked) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dy) > Math.abs(dx)) locked = true;
    }, { passive: true });

    this.mainEl.addEventListener('touchend', (e) => {
      // Hint'i her durumda zamanla — animasyon bitince temizlensin
      if (swipeEndTimer) clearTimeout(swipeEndTimer);
      swipeEndTimer = setTimeout(() => {
        this.mainEl.classList.remove('is-swiping');
        swipeEndTimer = null;
      }, 250);

      if (locked) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < ERO_SWIPE_THRESH) return;
      dx < 0 ? this.goTo(this.current + 1) : this.goTo(this.current - 1);
    });
  }
}

function eroGalleryInitAll() {
  document.querySelectorAll('.ero-gallery').forEach((root) => {
    if (!root._eroGallery) {
      root._eroGallery = new EroGallery(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', eroGalleryInitAll);
} else {
  eroGalleryInitAll();
}

document.addEventListener('shopify:section:load', eroGalleryInitAll);
 